import { Flex, IconButton, Tooltip } from "@chakra-ui/react";
import { useState } from "react";
import { FiCopy } from "react-icons/fi";

interface CopyProps {
  value?: string;
};

const CopyButton: React.FC<CopyProps> = ({
  value,
}) => {
  const [copied, setCopied] = useState<boolean>(false);

  return (
    <Flex>
      <Tooltip label={copied ? "Copied!" : "Copy to clipboard"} hasArrow placement="top">
        <IconButton
          aria-label="Copy to clipboard"
          icon={<FiCopy />}
          size="xs"
          variant="outline"
          onClick={() => {
            navigator.clipboard.writeText(value || "");
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
          }}
        />
      </Tooltip>
    </Flex>
  );
};

export default CopyButton;